import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

export const Container = styled.div`
  min-width: calc(100% - 88px);

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  hr {
    background: #e1e1e1;
    opacity: 1;
  }

  a {
    :hover {
      color: unset;
    }
  }

  .export-xls {
    background: #002f6c !important;
  }

  .height {
    background: transparent;
    border-color: #d3d3d3 !important;
    opacity: 1;
  }

  .container-fluid {
    max-width: 1460px;
  }

  .btn-new {
    border-radius: 4px;
    background: #ff6900;
    border: none;
  }

  .bg-white {
    border-radius: 8px;
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 8px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 4px;
    }
  }

  .bg-balance {
    border-radius: 8px;
    background: linear-gradient(268deg, #ff9e2d 0%, #ff6900 100%);
  }
`;

export const Filter = styled.div`
  h2 {
    color: #000;
    font-family: 'Roboto';
  }
`;

export const TableList = styled.div`
  .btn-icons {
    background: #ff842f;
    border-radius: 20px;
    padding: 6px 8px;
  }
  .min-w {
    min-width: 2410px;
  }
  .table {
    > div:first-child {
      padding: 0px !important;
    }
    div {
      border: none;
    }
  }

  .content {
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 13px;
      border: none;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 10px;
    }
  }

  .tb-header {
    background-color: #002f6c;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 12px 16px;
  }

  .tb-body {
    padding: 0 0.5rem;
  }

  .tb-header .tb-row button {
    color: #fff;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    justify-content: center;

    svg {
      color: #fff !important;
    }
  }

  /* .tb-header .tb-row button:last-child {
    width: 138px !important;
    min-width: 138px !important;
  }

  .tb-body .tb-row div:last-child {
    min-width: 138px !important;
    width: auto !important;
  } */

  .tb-header .tb-row button:not(:first-child) {
    width: 200px;
  }

  .tb-header .tb-row button:first-child {
    svg {
      display: none;
    }
  }

  .tb-header .tb-row {
    button:nth-child(1) {
      width: 180px;
    }
    button:nth-child(2) {
      width: 130px;
    }
    button:nth-child(4) {
      width: 120px;
    }
    button:nth-child(5) {
      width: 80px;
    }
    button:nth-child(6) {
      width: 140px;
    }
    button:nth-child(7) {
      width: 160px;
    }
    button:nth-child(8) {
      width: 170px;
    }
    button:nth-child(9) {
      width: 300px;
    }
    button:nth-child(11) {
      width: 100px;
    }
    button:nth-child(12) {
      width: 110px;
    }
    button:nth-child(14) {
      width: 130px;
    }
    button:nth-child(15) {
      width: 140px;
    }
    button:nth-child(16) {
      width: 150px;
    }
    button:nth-child(17) {
      width: 120px;
    }
    button:nth-child(18) {
      width: 110px;
    }
    button:nth-child(21) {
      width: 250px;
    }
    button:nth-child(23) {
      width: 250px;
    }
    button:last-child {
      width: 100px;
    }
  }

  .tb-body .tb-row {
    padding: 0.5rem 0.5rem;
    text-align: center;

    :not(:last-child) {
      border-bottom: 0.5px solid #e1e1e1;
    }

    div:not(:first-child) {
      color: #7e7e7e;
      font-family: 'Roboto';
      font-size: 16px;
      font-weight: 400;
      width: 200px;
      text-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    div:nth-child(1) {
      width: 180px;
    }
    div:nth-child(2) {
      width: 130px;
    }
    div:nth-child(4) {
      width: 120px;
    }
    div:nth-child(5) {
      width: 80px;
    }
    div:nth-child(6) {
      width: 140px;
    }
    div:nth-child(7) {
      width: 160px;
    }
    div:nth-child(8) {
      width: 170px;
    }
    div:nth-child(9) {
      width: 300px;
    }
    div:nth-child(11) {
      width: 100px;
    }
    div:nth-child(12) {
      width: 110px;
    }
    div:nth-child(14) {
      width: 130px;
    }
    div:nth-child(15) {
      width: 140px;
    }
    div:nth-child(16) {
      width: 150px;
    }
    div:nth-child(17) {
      width: 120px;
    }
    div:nth-child(18) {
      width: 110px;
    }
    div:nth-child(21) {
      width: 250px;
    }
    div:nth-child(23) {
      width: 250px;
    }
    div:last-child {
      width: 100px;
    }
  }

  @media screen and (min-width: 992px) {
    /* .number-id:not(:nth-child(5)) {
      min-width: 45px;
      width: auto;
    } */
    .number-id {
      padding: 0px 7px;
    }
  }
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .modal-content {
    border-radius: 8px;
    border: none;
  }
  .table-modal > div {
    padding: 0px !important;

    > div {
      padding: 0px;
      border: none;
    }
  }

  .btn-select-all {
    color: #6c757d;
    border-color: #6c757d;
    transition: all 0.3s ease-in-out;

    :hover {
      color: #fff;
      background-color: #002f6c;
      border-color: #002f6c;
    }
  }

  .btn-export {
    color: #fff;
    background-color: #ff6900;
    border-color: #ff6900;
  }

  .item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }
  label {
    cursor: pointer;

    input[type='checkbox'] {
      appearance: none;
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      min-width: 16px;
      border: 1px solid #8c8c8c;
      border-radius: 3px;
      background-color: #fff;
      cursor: pointer;
      position: relative;

      &:checked {
        background-color: #ff6900;
        border-color: #ff6900;

        &::after {
          content: '';
          position: absolute;
          left: 4px;
          top: 1px;
          width: 5px;
          height: 9px;
          border: 2px solid #fff;
          border-top: none;
          border-left: none;
          transform: rotate(45deg);
        }
      }
    }
  }
`;

export const ExportColumnsList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-flow: column;
  grid-template-rows: repeat(
    10,
    auto
  ); /* ajuste conforme a quantidade de linhas */

  .item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }
  label {
    cursor: pointer;

    input[type='checkbox'] {
      appearance: none;
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      min-width: 16px;
      border: 1px solid #8c8c8c;
      border-radius: 3px;
      background-color: #fff;
      cursor: pointer;
      position: relative;

      &:checked {
        background-color: #ff6900;
        border-color: #ff6900;

        &::after {
          content: '';
          position: absolute;
          left: 4px;
          top: 1px;
          width: 5px;
          height: 9px;
          border: 2px solid #fff;
          border-top: none;
          border-left: none;
          transform: rotate(45deg);
        }
      }
    }

    span {
      font-size: 14px;
    }
  }
`;

export const TableListModal = styled.div`
  .btn-icons {
    background: #ff842f;
    border-radius: 20px;
    padding: 6px 8px;
  }
  .min-w {
    min-width: 2410px;
  }
  .table {
    > div:first-child {
      padding: 0px !important;
    }
    div {
      border: none;
    }
  }

  .content {
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 13px;
      border: none;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 10px;
    }
  }

  .tb-header {
    background-color: #002f6c;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 12px 16px;
  }

  .tb-body {
    padding: 0 0.5rem;
  }

  .tb-header .tb-row button {
    color: #fff;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    justify-content: center;

    svg {
      color: #fff !important;
    }
  }

  /* .tb-header .tb-row button:last-child {
    width: 138px !important;
    min-width: 138px !important;
  }

  .tb-body .tb-row div:last-child {
    min-width: 138px !important;
    width: auto !important;
  } */

  .tb-header .tb-row button:not(:first-child) {
    width: 12%;
  }

  .tb-header {
    width: 100%;
  }

  .tb-header .tb-row {
    width: 100%;
    button:nth-child(1) {
      width: 6%;
    }
    button:nth-child(2) {
      width: 47%;
    }
    button:nth-child(3) {
      width: 47%;
    }
  }

  .tb-body {
    width: 100%;
    > div {
      width: 100%;
    }
  }

  .tb-body .tb-row {
    padding: 0.5rem 0.5rem;
    text-align: center;
    width: 100%;

    :not(:last-child) {
      border-bottom: 0.5px solid #e1e1e1;
    }

    div:not(:first-child) {
      color: #7e7e7e;
      font-family: 'Roboto';
      font-size: 16px;
      font-weight: 400;
      width: 12%;
      text-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    div:nth-child(1) {
      width: 6%;
    }
    div:nth-child(2) {
      width: 47%;
    }
    div:nth-child(3) {
      width: 47%;
    }
  }

  @media screen and (min-width: 992px) {
    .number-id:not(:nth-child(5)) {
      min-width: 45px;
      width: auto;
    }
    .number-id {
      padding: 0px 7px;
    }
  }
`;
